import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Alert } from "antd";

const { TextArea } = Input;

const ModalRejectHmo = ({ visible, onClose, onSubmit, user, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleFinish = async (values) => {
    await onSubmit({
      reason: values.reason || "",
    });
  };

  return (
    <Modal
      title="Reject HMO Registration"
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      {user && (
        <div style={{ marginBottom: "16px" }}>
          <Alert
            message={`Rejecting HMO for ${user.name}`}
            description={
              <div>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Provider:</strong> {user.hmo?.name || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Number:</strong> {user.hmo_number || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  A rejection notification email will be sent with your reason, prompting the user to update their HMO details.
                </p>
              </div>
            }
            type="warning"
            showIcon
          />
        </div>
      )}

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="reason"
          label="Reason for Rejection (Optional)"
          extra="This note will be included in the email sent to the customer."
        >
          <TextArea
            rows={4}
            placeholder="e.g. Invalid HMO number, name on card does not match user name, policy inactive with provider..."
          />
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "24px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" danger htmlType="submit" loading={loading}>
            Confirm Rejection
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalRejectHmo;
